import React, { createContext, useContext } from 'react'

export interface InfoBoxProps {
  forceSnackbar?: boolean
  forceSnackbarTop?: boolean
  className?: string
  boxClassName?: string
  icon?: string
  visibilityCondition?: boolean
}

export type InfoVariantType =
  | 'default'
  | 'error'
  | 'fallout'
  | 'success'
  | 'warning'
  | 'info'

export interface EnqueueInfoOptions {
  icon?: string
  variant?: InfoVariantType
}

export interface InfoBoxInformation {
  message: string
  options?: EnqueueInfoOptions
}

interface InfoBoxContextState {
  isOpen: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  currentInfo: InfoBoxInformation
  enqueueInfo: (message: string, options?: EnqueueInfoOptions) => void
  closeInfoBox: () => void
}

export const DEFAULT_INFO_BOX_STATE = {
  isOpen: false,
  setOpen: () => {},
  currentInfo: { message: '' },
  enqueueInfo: () => {},
  closeInfoBox: () => {},
}

export const InfoBoxContext = createContext<InfoBoxContextState>(
  DEFAULT_INFO_BOX_STATE
)

export const useInfoBoxInternal = (): InfoBoxContextState => {
  return useContext(InfoBoxContext)
}

type PublicInfoBoxState = Omit<
  InfoBoxContextState,
  'isOpen' | 'setOpen' | 'currentInfo'
>

export const useInfoBox = (): PublicInfoBoxState => {
  const { enqueueInfo, closeInfoBox } = useContext(InfoBoxContext)
  return { enqueueInfo, closeInfoBox }
}
